import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cozy%20warm%20evening%20room%20with%20friends%20gathered%20around%20screen%20watching%20anime%20together%2C%20glowing%20screens%20and%20warm%20coral%20ambient%20light%2C%20soft%20cushions%20and%20snacks%2C%20flat%20vibrant%20anime%20art%20style%2C%20joyful%20and%20comfortable%20community%20mood%2C%20clean%20composition%20with%20soft%20bokeh%20and%20gentle%20glow&width=1600&height=600&seq=cta-banner&orientation=landscape"
        alt="与同好一起看番的温馨插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/60"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-20 md:py-24 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50">
          现在就加入，找到愿意陪你追更的人
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm md:text-base text-background-100/90">
          无论是讨论剧情、安利作品，还是寻找同好，羞羞动漫社社区都欢迎你随时加入，畅所欲言。
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/community"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-lg bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            立即加入社区 <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-lg bg-background-50/10 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-background-50/20 transition-colors backdrop-blur-sm"
          >
            了解羞羞动漫社
          </Link>
        </div>
      </div>
    </section>
  );
}